






























import { Modal, notify, ModalMixin } from 'mycorems-app-shared';
import { HasTaskMixin } from '@/mixins';
import { DetailedEmailCampaign, ModalElement } from '@/types';
import { generateReport } from '../email-campaign';
import GenerateReportBtn from './GenerateReportBtn.vue';

export default HasTaskMixin.extend({
  mixins: [ModalMixin],
  props: {
    emailCampaignId: {
      type: String,
      required: true,
    },
    campaign: {
      type: String,
      required: true,
    },
    subject: {
      type: String,
      required: true,
    },
    sentAt: {
      type: String,
      required: true,
    },
  },
  methods: {
    generate(): void {
      this.task = generateReport(this.emailCampaignId);
      this.task.then((emailCampaign: DetailedEmailCampaign) => {
        this.$emit('ok', emailCampaign);
        (this.$refs.modal as ModalElement).hide();
        notify.success('Email Report generated.');
      });
    },
  },
  components: {
    modal: Modal,
    'generate-report-btn': GenerateReportBtn,
  },
});
